import React from "react";

export default function bng() {
  return <div></div>;
}
